import React, { useState } from 'react';  
import { motion } from 'framer-motion';  
import { CheckCircle2, XCircle, ListCheck } from 'lucide-react';  
  
const VerificarCartilla = ({ historial, onCerrar }) => {  
  const [numerosCartilla, setNumerosCartilla] = useState('');  
  const [resultado, setResultado] = useState(null);  
  
  const verificarGanador = () => {  
    const numeros = numerosCartilla.split(',').map(n => parseInt(n.trim())).filter(n => !isNaN(n) && n >= 1 && n <= 54);  
    if (numeros.length !== 16) {  
      alert('¡Ingresa exactamente 16 números separados por comas! Ej: 1,5,12,23,...');  
      return;  
    }  
  
    const idsSacados = historial.map(c => c.id);  
    const gano = numeros.every(num => idsSacados.includes(num));  
  
    setResultado({  
      gano,  
      numerosFaltantes: gano ? [] : numeros.filter(num => !idsSacados.includes(num))  
    });  
  };  
  
  return (  
    <motion.div  
      className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4"  
      initial={{ opacity: 0 }}  
      animate={{ opacity: 1 }}  
      onClick={onCerrar}  
    >  
      <motion.div  
        className="bg-white rounded-2xl p-6 max-w-md w-full max-h-[80vh] overflow-y-auto"  
        initial={{ scale: 0.9, opacity: 0 }}  
        animate={{ scale: 1, opacity: 1 }}  
        onClick={(e) => e.stopPropagation()}  
      >  
        <div className="flex items-center gap-3 mb-4">  
          <ListCheck className="w-6 h-6 text-green-600" />  
          <h3 className="font-bold text-lg">Verificar Cartilla</h3>  
        </div>  
        <p className="text-gray-600 mb-4 text-sm">Ingresa los 16 números de tu cartilla (separados por comas):</p>  
        <textarea  
          value={numerosCartilla}  
          onChange={(e) => setNumerosCartilla(e.target.value)}  
          placeholder="Ej: 1,5,12,23,7,34,15,28,42,9,51,3,19,36,44,54"  
          className="w-full p-3 border border-gray-300 rounded-lg mb-4 resize-none h-24 text-sm"  
        />  
        <button  
          onClick={verificarGanador}  
          className="w-full px-4 py-2 bg-blue-500 hover:bg-blue-600 text-white rounded-lg font-medium mb-4"  
        >  
          Verificar  
        </button>  
        {resultado && (  
          <div className={`p-4 rounded-lg ${  
            resultado.gano ? 'bg-green-100 border border-green-300' : 'bg-red-100 border border-red-300'  
          }`}>  
            {resultado.gano ? (  
              <>  
                <CheckCircle2 className="w-8 h-8 text-green-600 mx-auto mb-2" />  
                <p className="font-bold text-green-800">¡GANASTE! Tu cartilla está completa.</p>  
              </>  
            ) : (  
              <>  
                <XCircle className="w-8 h-8 text-red-600 mx-auto mb-2" />  
                <p className="font-bold text-red-800">No ganaste aún.</p>  
                <p className="text-sm text-red-700 mt-2">Faltan: {resultado.numerosFaltantes.join(', ')}</p>  
              </>  
            )}  
          </div>  
        )}  
        <button  
          onClick={onCerrar}  
          className="w-full px-4 py-2 bg-gray-500 hover:bg-gray-600 text-white rounded-lg font-medium"  
        >  
          Cerrar  
        </button>  
      </motion.div>  
    </motion.div>  
  );  
};  
  
export default VerificarCartilla;